import { RootState } from '@store';
import { selectOrder } from './base';

export const selectSnapshot = (state: RootState) => {
  return selectOrder(state)?.pimSnapshot;
};

export const selectSnapshotVehicleType = (state: RootState) => {
  return selectSnapshot(state)?.vehicleType;
};

export const selectVehicleUsageCode = (state: RootState) => {
  return selectSnapshot(state)?.vehicleUsageCode;
};
